module.exports = __webpack_public_path__ + "static/media/foot-and-basket-signup.e718cd7e.webp";